/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ArchetypeResponseHeader } from "./ArchetypeResponseHeader";
import * as t from "io-ts";

/**
 * The list of responses related to the archetype that can be edited in mock resource creation.
 */

// required attributes
const ArchetypeResponseR = t.interface({
  headers: t.readonlyArray(
    ArchetypeResponseHeader,
    "array of ArchetypeResponseHeader"
  ),

  injectable_parameters: t.readonlyArray(t.string, "array of string"),

  status: t.Integer
});

// optional attributes
const ArchetypeResponseO = t.partial({
  body: t.string,

  id: t.string
});

export const ArchetypeResponse = t.intersection(
  [ArchetypeResponseR, ArchetypeResponseO],
  "ArchetypeResponse"
);

export type ArchetypeResponse = t.TypeOf<typeof ArchetypeResponse>;
